module.exports = "<div data-bind=\"foreach:items\">\n  <div data-bind=\"style: $parent.style,\n  css: { 'y-dragging': dragging },\n  dragZone:{\n    name: $parent.name,\n    dragStart: $parent.dragStart,\n    dragEnd: $parent.dragEnd\n  },\n  dropZone: {\n    accepts: $parent.name,\n    drop: $parent.drop\n  },\n  dragEvents: {\n    accepts: $parent.name,\n    dragOver: $parent.reorder,\n    data: { items: $parent.items, item: $data }\n  }\">\n  <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/dragable/sortablelist/index.html
// module id = 510
// module chunks = 0